import React from 'react';
import styles from './ApplyModalBody.module.css';
import ApplyFileUpload from './ApplyFileUpload';

const SUBMIT_ITEMS = [
  '프로필 정보 (기본 정보, 신체 정보)',
  '프로필 사진',
  '자기소개 영상',
  '경력 및 필모그래피',
];

function RoleSelector({ roles, selectedRoleId, onSelect }) {
  return (
    <div className={styles.roleSelector}>
      <p className={styles.roleSelectorLabel}>
        지원 역할 <span className={styles.roleSelectorRequired}>*</span>
      </p>
      <div className={styles.roleSelectorOptions}>
        {roles.map((role) => (
          <label
            key={role.id}
            className={`${styles.roleOption} ${selectedRoleId === role.id ? styles.roleOptionSelected : ''}`}
          >
            <input
              type="radio"
              name="applyRole"
              value={role.id}
              checked={selectedRoleId === role.id}
              onChange={() => onSelect(role.id)}
              className={styles.roleRadio}
            />
            <div className={styles.roleInfo}>
              <span className={styles.roleName}>{role.name}</span>
              <span className={styles.roleMeta}>
                {[role.gender, role.ageRange].filter(Boolean).join(' · ')}
              </span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}

function SubmitInfo() {
  return (
    <div className={styles.submitInfo}>
      <p className={styles.submitInfoTitle}>제출되는 자료</p>
      <ul className={styles.submitInfoList}>
        {SUBMIT_ITEMS.map((item, idx) => (
          <li key={idx} className={styles.submitInfoItem}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

function ApplyModalBody({
  roles,
  selectedRoleId,
  onRoleSelect,
  bio,
  onBioChange,
  files,
  onFilesChange,
  videoLink,
  onVideoLinkChange,
}) {
  return (
    <div className={styles.body}>
      <RoleSelector roles={roles} selectedRoleId={selectedRoleId} onSelect={onRoleSelect} />

      <div className={styles.fieldGroup}>
        <label className={styles.fieldLabel}>자기소개</label>
        <textarea
          className={styles.textarea}
          placeholder="text"
          value={bio}
          onChange={(e) => onBioChange(e.target.value)}
          maxLength={1000}
        />
      </div>

      <div className={styles.fieldGroup}>
        <label className={styles.fieldLabel}>파일 첨부</label>
        <ApplyFileUpload files={files} onFilesChange={onFilesChange} />
      </div>

      <div className={styles.fieldGroup}>
        <label className={styles.fieldLabel}>영상 링크</label>
        <input
          type="url"
          className={styles.urlInput}
          placeholder="http://"
          value={videoLink}
          onChange={(e) => onVideoLinkChange(e.target.value)}
        />
      </div>

      <SubmitInfo />
    </div>
  );
}

export default ApplyModalBody;
